import styled from "@emotion/styled";

import { theme } from "shared/lib/styles";

import { Loading } from "scmp-app/components/common/loading";
import { ContentItemSearch } from "scmp-app/components/content/content-item-render/variants/search";
import { HeaderContainer } from "scmp-app/components/search/search-result-panel/search-result-list/styles";

export const Item = styled(ContentItemSearch)`
  padding-block: 16px;
  ${theme.breakpoints.up("desktop")} {
    padding-block: 0;
  }
`;

export const List = styled.div`
  > ${Item} + ${Item} {
    border-block-start: 1px solid rgba(0, 0, 0, 0.2);
  }

  ${HeaderContainer} + & > ${Item}:first-of-type {
    border-block-start: 1px solid rgba(0, 0, 0, 0.2);
  }
`;

export const StyledLoading = styled(Loading)`
  margin-block: 40px;
`;
